import { createFileRoute } from "@tanstack/react-router";
import { NotFound } from "@/components/Organisms/NotFound";

export const Route = createFileRoute("/_authenticated/(web-app)/_web/$")({
	component: NotFound,
});
